<div class="row">
    <div class="col-12 col-md-8">
        <div class=" text-center border" >
            <div class="ag-bg-red  d-flex justify-content-between p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <span class="text-white align-self-center">Membres</span>
                <span class="text-white align-self-center">Total: <span class="text-white">{{datas.length}}</span></span>
            </div>
            <div class="p-1" style="height: 70vh; overflow-y: scroll; ">
                <ng-container *ngIf="vue=='list'">
                    <div *ngFor="let d of datas; let i=index" class="d-flex justify-content-between border mb-3 {{i%2==0 ? 'bg-light':'bg-white'}}" (click)="current=d" style="cursor: pointer;">
                        <div class="d-flex justify-content-start">
                          <div class="me-1">
                            <img src="assets/avatar.jpg" height="50" width="50" class="img-thumbnail" alt="..." style="border-radius: 50%;">
                          </div>
                          <div class="align-self-center h6">
                            <span class="text-dark"><strong>{{d.student?.lastname}} </strong></span>
                            <span class="text-dark"><small>{{d.student?.firstname}}</small></span>
                          </div>
                        </div>
                        <div class="align-self-center h6">
                          <span>{{d.student?.birthdate | date:"dd-MM-yyyy"}}</span>
                          <span class="mx-1" (click)="launchEditting(d)"> <i class="fa fa-edit"></i></span>
                        </div>
                      </div>
                </ng-container>
                <ng-container *ngIf="vue=='photo'">
                    <div class="row" > 
                        <div *ngFor="let d of datas;" class="col-12 col-md-2 border mb-3 pointer" (click)="current=d" style="cursor: pointer;">
                            <img src="assets/avatar.jpg" height="150" width="100" class="img-thumbnail" alt="...">
                            <span class="text-dark h6 text-center"><strong><small>{{d.student?.lastname}}</small></strong></span> <br>
                            <span class="text-dark h6 text-center"><strong><small>{{d.student?.firstname}}</small></strong></span>
                        </div>
                    </div>
                 
                </ng-container>
                <ng-template #noData>
                  <p class="h4 text-center fw-bold text-dark">Aucune donnée disponible; Veuillez choisir une classe</p>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="col-12 col-md-4">
        <div class=" text-center border ">
            <div class="ag-bg-red  d-flex justify-content-center" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <h6 class="text-white align-self-center">Information sur l'élève</h6>
            </div>
            <div class="p-1" style="height: 70vh; overflow-y: scroll; ">
                <div class="d-flex justify-content-start mb-3">
                    <div class="me-1">
                      <img src="assets/avatar.jpg" height="200" width="150" class="img-thumbnail" alt="...">
                    </div>
                    <div class="align-self-center text-start">
                        <h6><strong>{{current?.student?.lastname}} </strong> {{current?.student?.firstname}}</h6>
                        <h6><small>Née le ({{current?.student?.birthdate | date:"dd-MM-yyyy"}})</small></h6>
                      <ul class="list-unstyled">
                        <li><strong class="g-text-danger me-1">Autorisation de sortie:</strong> </li>
                        <li><strong class="g-text-danger me-1">Allergies alimentaire:</strong> </li>
                      </ul>
                    </div>
                  </div>
                  <div class="text-start p-1">
                    <ul class="list-unstyled">
                        <li><strong class="g-text-danger me-1"><i class="fa fa-home"></i>:</strong> {{current?.student?.address}}</li>
                        <li><strong class="g-text-danger me-1"><i class="fa fa-phone"></i>:</strong> {{current?.student?.phone}}</li>
                        <li><strong class="g-text-danger me-1"><i class="fa fa-envelope"></i>:</strong> {{current?.student?.email}}</li>
                      </ul>
                      <h6 class="g-text-danger">Tuteurs légaux</h6>
    
                      <h5><strong>Père</strong></h5>
                      <ul class="list-unstyled text-start">
                        <li><strong class="g-text-danger me-1"><i class="fa fa-home"></i>:</strong> {{current?.student?.parent?.father_address}}</li>
                        <li><strong class="g-text-danger me-1"><i class="fa fa-phone"></i>:</strong> {{current?.student?.parent?.father_phone}}</li>
                        <li><strong class="g-text-danger me-1"><i class="fa fa-envelope"></i>:</strong> {{current?.student?.parent?.father_email}}</li>
                      </ul>
    
                      <h5><strong>Mère</strong></h5>
                      <ul class="list-unstyled text-start">
                        <li><strong class="g-text-danger me-1"><i class="fa fa-home"></i>:</strong> {{current?.student?.parent?.mother_address}}</li>
                        <li><strong class="g-text-danger me-1"><i class="fa fa-phone"></i>:</strong> {{current?.student?.parent?.mother_phone}}</li>
                        <li><strong class="g-text-danger me-1"><i class="fa fa-envelope"></i>:</strong> {{current?.student?.parent?.mother_email}}</li>
                      </ul>
                      
                      <h5><strong>Tuteur</strong></h5>
                      <ul class="list-unstyled text-start">
                        <li><strong class="g-text-danger me-1"><i class="fa fa-home"></i>:</strong> {{current?.student?.parent?.tutor_address}}</li>
                        <li><strong class="g-text-danger me-1"><i class="fa fa-phone"></i>:</strong> {{current?.student?.parent?.tutor_phone}}</li>
                        <li><strong class="g-text-danger me-1"><i class="fa fa-envelope"></i>:</strong> {{current?.student?.parent?.tutor_email}}</li>
                      </ul>
                  </div>
                 
            </div>
        </div>
    </div>
</div>